<template>
  <div style="display: contents">
    <b-row>
      <b-col md="12" class="mb-3">
        <div class="package-name-background p-2"><p class="mb-0">{{pack.name}}</p></div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" style="max-width:50%;">
        <h5 class="package-title" v-translate>Services included</h5>
        <hr>
        <p style="white-space: pre-line;">{{ pack.included }}</p>
      </b-col>
      <b-col md="6">
        <h5 class="package-title" v-translate>Services not included</h5>
        <hr>
        <p style="white-space: pre-line;">{{ pack.notIncluded }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="mt-2">
        <p style="white-space: pre-line;" v-if="pack.description">{{ pack.description}}</p>
      </b-col>
    </b-row>
    <FlightInfo :info="pack.flightInfo" v-if="pack.flightInfo" />
    <b-row v-if="showPrices">
      <b-col md="12">
        <h6 class="package-title" v-translate>Price details</h6>
        <div class="table-responsive">
          <table class="table table-sm mb-0">
            <thead class="t-head thead-light">
              <tr>
                <td v-translate>Category</td>
                <td v-translate>Board basis</td>
                <td v-translate>Booking price</td>
                <td v-translate>Price</td>
                <td colspan="3"></td>
              </tr>
            </thead>
            <tbody>
              <template v-for="category in pack.categories">
                <categoryInfo
                  :result="result"
                  :category="category"
                  :currency="currency"
                  :key="'categoryInfo' + category.id" />
              </template>
            </tbody>
          </table>
          <!-- <p class="package-warning" v-translate>*Attention! The reduced price is valid subject to availability!</p> -->
        </div>
      </b-col>
    </b-row>
    <b-row v-if="showExtras">
      <Extras :extras="pack.categories[0].extras" :currency="currency" />
    </b-row>
    <b-row v-if="showNotes">
      <b-col md="12">

        <ul class="list-inline">
          <li class="list-group-item"><b v-translate>NOTE:</b> <span v-translate> the prices and supplements displayed are calculated by total reservation!</span> </li>
          <li class="list-group-item"><b v-translate>NOTE:</b> <span v-translate> additional / optional items that have the displayed value are not included in the booking price!</span></li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import categoryInfo from '@/app/private/shared/components/category_info'
import FlightInfo from './flight_info'
import Extras from './extras'

export default {
  name: 'PackageInfo',
  props: {
    result: {
      type: Object
    },
    pack: {
      type: Object,
      required: true
    },
    currency: {
      type: String
    },
    showPrices: {
      type: Boolean,
      default: true
    },
    showExtras: {
      type: Boolean,
      default: true
    },
    showNotes: {
      type: Boolean,
      default: true
    }
  },
  components: { categoryInfo, FlightInfo, Extras }
}
</script>
